import { render, staticRenderFns } from "./GalleryEdit.vue?vue&type=template&id=6f1b580c&scoped=true&"
import script from "./GalleryEdit.vue?vue&type=script&lang=js&"
export * from "./GalleryEdit.vue?vue&type=script&lang=js&"
import style0 from "./GalleryEdit.vue?vue&type=style&index=0&id=6f1b580c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1b580c",
  null
  
)

export default component.exports